module.exports = __webpack_public_path__ + "img/bank-title-en.3e41cbc0.png";